"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationContext = void 0;
const react_1 = __importStar(require("react"));
const Splash_1 = __importDefault(require("./Splash"));
exports.LocationContext = (0, react_1.createContext)(undefined);
const LocationView = ({ locationGetter, getUIComponents, getImage, children, }) => {
    const [location, setLocation] = (0, react_1.useState)(undefined);
    const defaultLocation = {
        latitude: 45,
        longitude: -93,
    };
    (0, react_1.useEffect)(() => {
        locationGetter().then((loc) => {
            if (!loc) {
                setLocation(defaultLocation);
            }
            else {
                setLocation(loc);
            }
        });
    }, []);
    if (!location) {
        return (react_1.default.createElement(Splash_1.default, { spinner: true, getUIComponents: getUIComponents, getImage: getImage }));
    }
    return (react_1.default.createElement(exports.LocationContext.Provider, { value: location }, children));
};
exports.default = LocationView;
